var map = {
	"./dis-banzu.svg": "37e7",
	"./dis-feibanzu.svg": "176b",
	"./dis-jinxingzhong.svg": "384a",
	"./dis-quyue.svg": "7a089",
	"./dis-wu.svg": "0688",
	"./dis-wufawancheng.svg": "51a0",
	"./dis-xiaoyuandian.svg": "7963",
	"./dis-yijihua.svg": "5c2a",
	"./dis-yipaiqian.svg": "9871",
	"./dis-yiquxiao.svg": "a007",
	"./dis-yiwancheng.svg": "b29f",
	"./dis-zichantubiao.svg": "fcd2",
	"./template_address.jpg": "4e822"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b19";